
const agreements = state => state.agreements;
const serviceCase = state => state.serviceCase;

export default {
  agreements,
  serviceCase
};
